import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'; // 1. Redux hooks
import moment from 'moment';
import { TimePicker } from 'antd';

import { pushData } from '../utilities/pushData'; // 2. New Action Creator
import getDisabled from './getDisabled';

const allHours = [];
for (let i = 0; i < 24; i++) {
  allHours.push(i);
}

export default function TimeChooser({ inspector = {} }) {
  const dispatch = useDispatch();

  // 3. Selectors: Pick only the needed fields
  const date = useSelector(state => state.date);
  const time = useSelector(state => state.time);
  const duration = useSelector(state => state.duration);
  const calendar = useSelector(state => state.calendar);
  const restrict_schedule = useSelector(state => state.project?.restrict_schedule);

  // 4. Helper to match your old API
  const push = (payload) => dispatch(pushData(payload));

  // is an hour disabled if a project is scheduled in it?
  const [disabledHours, disabledMinutes] = getDisabled(date, calendar, inspector.availability);

  // Initial Sync Effect
  useEffect(function () {
    // This re-dispatches the current time/duration on mount. 
    // Kept to match your original logic, likely for validation triggers.
    if (duration) push({ time, duration });
    else push({ time });
  }, []); // Run once on mount

  // Auto-set duration Effect
  useEffect(
    function () {
      if (time && !duration) {
        push({ duration: moment().startOf('day') });
      }
    },
    [time, duration, dispatch] // Added correct dependencies
  );

  let excludedDurationHours;
  if (time) {
    const h = time.hours();
    const de = disabledHours();
    const durationEnd = de.filter((e) => e > h).sort((a, b) => (a > b ? 1 : -1));
    durationEnd.push(24);

    const stop = durationEnd[0] - h;
    excludedDurationHours = allHours.filter((h) => h >= stop);
  }

  // console.log('date', date, 'time', time, duration);

  return (
    <div>
      <div className="bold padding-top-1">Time</div>
      <TimePicker
        value={time}
        disabledHours={restrict_schedule ? disabledHours : undefined}
        disabledMinutes={restrict_schedule ? disabledMinutes : undefined}
        format="h:mm a"
        onChange={(newTime) => {
          push({ time: newTime });
        }}
        minuteStep={5}
      />
      <div className="bold padding-top-1">Duration</div>
      {time && (
        <TimePicker
          disabledHours={() => (restrict_schedule ? excludedDurationHours : undefined)}
          // disabledMinutes={disabledMinutes}
          format="HH:mm"
          placeholder="Duration"
          minuteStep={15}
          onChange={(newDuration) => {
            if (!newDuration) {
              push({ duration: null });
              return;
            }
            push({ duration: moment({ hours: newDuration.hours(), minutes: newDuration.minutes() }) });
          }}
          value={duration}
        />
      )}
    </div>
  );
}